import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

import "./CorporateDetails.css";
import EmployeeTable from "./EmployeeTable";

// Define the Modal component outside CorporateDetails otherwise it re-mounts every time
// the parent re-renders, losing internal state.
function Modal({ show, onClose, children }) {
  if (!show) {
    return null; // Don't render if not visible
  }

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()
      }>
        {/* Prevent closing when clicking inside */}
        {children}
      </div>
    </div>
  );
}


function CorporateDetails() {
  const { companyCode } = useParams();

  const [company, setCompany] = useState(null);
  const [masterEmployees, setMasterEmployees] = useState([]);
  const [registeredEmployees, setRegisteredEmployees] = useState([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Modal state
  const [showModal, setShowModal] = useState(false);  
  const [editData, setEditData] = useState({});

  const handleOpenModal = () => {
    setShowModal(true);
    setEditData(company);     // Copy company contact that needs to be updated
  }
  
  const handleCloseModal = () => {
    setShowModal(false);
    setEditData({});
  }

  useEffect(() => {
    const fetchCorporate = async () => {
      try {
       const resCorp = await axios.get(`https://backend-xhl4.onrender.com/CorporateRoute/corporate/${companyCode}`);
        setCompany(resCorp.data);

        const resMaster = await axios.get(`https://backend-xhl4.onrender.com/CorporateMasterRoute/employees/${companyCode}`);
        setMasterEmployees(resMaster.data.employees || []);

        const resReg = await axios.get(`https://backend-xhl4.onrender.com/CorporateRoute/registered/${companyCode}`);
        setRegisteredEmployees(resReg.data.registeredEmployees || []);

      } catch (err) {
        setError("Failed to load corporate details.");
      } finally {
        setLoading(false);
      }
    };

    fetchCorporate();
  }, [companyCode]);

  const totalEmployees = masterEmployees.length;
  const registeredCount = registeredEmployees.length;
  const notRegistered = totalEmployees - registeredCount;

 // Save Company Contact's updated profile
  const handleSave = async () => {

    if(!editData.contactPerson || !editData.email || !editData.phone) {
      console.error("All fields are required.");
      return;
    }

    try {
      const res = await fetch(`https://backend-xhl4.onrender.com/CorporateRoute/update/${companyCode}`,
      {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(editData)
        }
      );

      if (res.ok) {
        await res.json();
        setCompany(editData);
      } else {
        console.error("Update failed");
      }
    } catch (error) {
      console.error("Error updating:", error);
    }
    setShowModal(false);
  };

  return (
    <div className="corporate-details-page">
      
      {loading && <p className="loading-text">Loading details...</p>}
      {error && <p className="error-text">{error}</p>}

      {/* Company Header */}
      {company && (
         <div>
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", gap: "80px" }}>
            <div className="company-header">
              <h1>{company.companyName}</h1>
              <p><strong>Contact Person:</strong> {company.contactPerson}</p>
              <p><strong>Email:</strong> {company.email}</p>
              <p><strong>Phone:</strong> {company.phone}</p>
              <button className="view-btn" onClick={handleOpenModal}> Edit Details </button>
              {/* ---------- EDIT MODAL ---------- */}
              <Modal show={showModal} onClose={handleCloseModal}>
                <div className="corporate-modal-content">
                  <h2>
                    Edit Details
                  </h2>
                    <p>Name
                      <input required type="text" style={inputStyle} value={editData.contactPerson}
                        onChange={(e) =>
                          setEditData({ ...editData, contactPerson: e.target.value })
                        }
                      />
                    </p>
                    <p>Email
                      <input required type="email" style={inputStyle} value={editData.email}
                        onChange={(e) =>
                          setEditData({ ...editData, email: e.target.value })
                        }
                      />
                    </p>
                    <p>
                      Phone
                      <input required style={inputStyle} type="text" value={editData.phone}
                        onChange={(e) =>
                          setEditData({ ...editData, phone: e.target.value })
                        }
                      />
                    </p>
                  {/* BUTTONS */}
                  <div style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "12px",
                    marginBottom: "10px",
                  }}>
                    <button className="view-btn" onClick={handleCloseModal}>
                      Cancel
                    </button>
                    <button className="view-btn" onClick={handleSave}>
                      Save
                    </button>
                  </div>
                </div>
              </Modal >
            </div>

            {/* Statistic Cards */}
            <div className="stats-card-container">
              <div className="stats-card">
                <h3>Total Employees</h3>
                <p>{totalEmployees}</p>
              </div>

              <div className="stats-card">
                <h3>Registered Employees</h3>
                <p>{registeredCount}</p>
              </div>

              <div className="stats-card">
                <h3>Not Registered</h3>
                <p>{notRegistered}</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Master Employee Table */}
      <h2 className="section-title">Employee Master List</h2>
      <EmployeeTable
        data={masterEmployees.map(emp => ({
          empId: emp.empId,
          name: emp.name,
          department: emp.department || "",
          registered: emp.registered
        }))}
        showRegistrationFilter={true}
      />

      {/* Registered Employee Table */}
      {/* <h2 className="section-title" style={{ marginTop: "40px" }}>
        Registered Employees
      </h2>
      <EmployeeTable
        data={registeredEmployees.map(emp => ({
          empId: emp.empId,
          name: emp.name || "N/A",
          department: emp.department || "N/A",
          registered: true
        }))}
        showRegistrationFilter={false}
      /> */}

    </div>
  );
}

// inline input style
const inputStyle = {
  width: "100%",
  padding: "8px",
  margin: "5px 0 10px 0",
  borderRadius: "6px",
  border: "1px solid #ccc",
};
export default CorporateDetails;
